<template>
  <div>
    <page-intro>
      <template v-slot:heading>Мои пользователи</template>
      <template v-slot:info>
        Добавляйте новых пользователей, управляйте их правами доступа.
        Стоимость добавления пользователя можно узнать ознакомившись с <router-link
          class="link"
          :to="{
            name: 'plans'
          }">
          тарифами
        </router-link>
      </template>
      <template v-slot:controls>
        <div>
          <el-button
            type="primary"
            class="w-100 mb-20"
            :disabled="!$store.state.user.accInfo.isAdmin"
            @click="handleCreateUser">
            Добавить пользователя
          </el-button>
          <instruction-link name="userCreation">Инструкция по добавлению</instruction-link>
        </div>
      </template>
    </page-intro>

    <w-users-list :users="users" @edit-user="handleEditUser" />

    <create-user-dialog
      :visible.sync="isCreateUserDialogVisible" />

    <edit-user-dialog
      :only-admin-id="theOnlyAdminId"
      :visible.sync="isEditUserDialogVisible"
      :user-id="editingUserId" />
  </div>
</template>

<script>
  import PageIntro from '@/components/PageIntro.vue'
  import InstructionLink from '@/components/InstructionLink.vue'
  import wUsersList from './UsersList'
  import CreateUserDialog from './CreateUserDialog'
  import EditUserDialog from './EditUserDialog'

  export default {
    components: {
      wUsersList,
      CreateUserDialog,
      EditUserDialog,
      PageIntro,
      InstructionLink
    },

    data() {
      return {
        isCreateUserDialogVisible: false,
        isEditUserDialogVisible: false,
        editingUserId: ''
      }
    },

    computed: {
      users() {
        return this.$store.state.users.users
      },

      theOnlyAdminId() {
        const admins = this.users.filter(user => user.isAdmin)

        if (admins.length === 1) {
          return admins.pop().id
        }

        return ''
      }
    },

    methods: {
      handleEditUser(userId) {
        this.editingUserId = userId
        this.isEditUserDialogVisible = true
      },

      handleCreateUser() {
        this.editingUserId = ''
        this.isCreateUserDialogVisible = true
      }
    }
  }
</script>
